import { ImagePlusIcon } from "lucide-react"
import { useTranslation } from "react-i18next"

interface UploadOptionsProps {
  onUploadClick: () => void
}

export function UploadOptions({ onUploadClick }: UploadOptionsProps) {
  const { t } = useTranslation()

  return (
    <div
      className="flex flex-col items-center justify-center border-2 border-dashed rounded-md p-6 cursor-pointer hover:bg-accent/50 transition-colors"
      onClick={onUploadClick}
    >
      <ImagePlusIcon className="h-8 w-8 mb-2 text-muted-foreground" />
      <span className="text-sm">{t('common.takePhoto')}</span>
      <span className="text-xs text-muted-foreground">{t('common.fileTypes')}</span>
    </div>
  )
}
